import React from 'react';
import './NavBar.css';

function NavBar({ activeGame, onGameChange }) {
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <h1 className="navbar-title">Our 4th Anniversary Puzzles ❤️</h1>
        <div className="navbar-buttons">
          <button
            className={`nav-button ${activeGame === 'connections' ? 'active' : ''}`}
            onClick={() => onGameChange('connections')}
          >
            Connections
          </button>
          <button
            className={`nav-button ${activeGame === 'crossword' ? 'active' : ''}`}
            onClick={() => onGameChange('crossword')}
          >
            Mini Crossword
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;

